exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/index.js??postcss!../../../node_modules/font-awesome/css/font-awesome.css"), "");
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato|Roboto);", ""]);

// module
exports.push([module.id, "label {\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\nh4 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Jesussandrea/Documents/proyectos/ngsquare/src/app/crear/crear.component.css
// module id = ../../../../../src/app/crear/crear.component.css
// module chunks = main